import styled from "styled-components";
export const LTImg = styled.img `
	position: absolute;
	left: 0;
	top: 0;
	height: 16px;
	border-radius: 6px 2px 2px 0;
`;
export const RTImg = styled.img `
	position: absolute;
	right: 0;
	top: 0;
	height: 16px;
	border-radius: 2px 6px 0 2px;
`;
export const Bottom = styled.div `
	width: 100%;
	position: absolute;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;
